module.exports = __webpack_public_path__ + "img/LisaA.a659ef0.png";